// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-loader__footer[data-v-e80d8620]{text-align:center;font-weight:700;padding:0 1rem .5rem}", ""]);
// Exports
module.exports = exports;
